import React from "react";

export default function InfoCardImage({ src, alt = "description", maxHeight = 160, style = {} }) {
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                boxSizing: "border-box",
                ...style,
            }}
        >
            <img
                src={src}
                alt={alt}
                style={{
                    height: "100%",
                    maxHeight: maxHeight,
                    width: "auto",
                    objectFit: "contain",
                }}
            />
        </div>
    );
}